const EXPERIMENT_BADGE_COLOR_CLASSES = [
  "border-chart-1/40 bg-chart-1/5 text-chart-1",
  "border-chart-2/40 bg-chart-2/5 text-chart-2",
  "border-chart-3/40 bg-chart-3/5 text-chart-3",
  "border-chart-4/40 bg-chart-4/5 text-chart-4",
  "border-chart-primary/40 bg-chart-primary/5 text-chart-primary",
  "border-chart-secondary/40 bg-chart-secondary/5 text-chart-secondary",
  "border-support-primary/40 bg-support-primary/5 text-support-primary",
  "border-support-secondary/40 bg-support-secondary/5 text-support-secondary",
  "border-testing-1/30 bg-testing-1/5 text-testing-1/80",
  "border-testing-2/40 bg-testing-2/5 text-testing-2",
  "border-warning/45 bg-warning/5 text-warning",
  "border-success/40 bg-success/5 text-success",
  "border-interactive/40 bg-interactive/5 text-interactive",
  "border-negative/40 bg-negative/5 text-negative",
  "border-positive/40 bg-positive/5 text-positive",
] as const

/** FNV-1a 32-bit — spreads keys better than polynomial rolling hash for short strings. */
function fnv1a32(input: string) {
  let h = 2166136261
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

function fnv1a32ReversedCharOrder(name: string) {
  let h = 2166136261
  for (let i = name.length - 1; i >= 0; i--) {
    h ^= name.charCodeAt(i)
    h = Math.imul(h, 16777619)
  }
  return h >>> 0
}

function experimentColorIndex(name: string) {
  const forward = fnv1a32(name)
  const backward = fnv1a32ReversedCharOrder(name)
  let mix = forward ^ backward ^ (forward >>> 12) ^ (backward << 20)
  mix = Math.imul(mix ^ (mix >>> 16), 2246822519) >>> 0
  mix = Math.imul(mix ^ (mix >>> 13), 3266489917) >>> 0
  return mix
}

export function getExperimentBadgeClassName(experimentName: string) {
  const mix = experimentColorIndex(experimentName)
  const index = mix % EXPERIMENT_BADGE_COLOR_CLASSES.length
  return EXPERIMENT_BADGE_COLOR_CLASSES[index]
}
